import React from "react";

function AboutUs() {
  return (
    <div className="container mt-4 mt-lg-5">
      <h2>About Us</h2>
      <p>
        Welcome to <strong>EthiocarHub</strong>, your trusted marketplace for cars in Ethiopia.  
        We connect buyers and sellers, offering a wide range of new, used, electric, 
        and rental cars from private sellers, brokers, and dealerships.  
      </p>

      <p>
        Our goal is to make car trading simple, transparent, and accessible.  
        Whether you're looking to buy your next car, rent, or sell, 
        EthiocarHub provides you with the right tools and exposure.
      </p>

      <p>
        EthiocarHub is operated and managed by experienced mechanical and automotive engineers, 
        ensuring expert guidance and reliable service.
      </p>

      <p>
        Thank you for choosing <strong>EthiocarHub</strong> as your automotive partner!
      </p>
    </div>
  );
}

export default AboutUs;
